// extracted by mini-css-extract-plugin
module.exports = {"date":"DeadlineDates_date___T071"};